<template>
    <div>
        <div class="clearfix pl-0">

            <div v-if="true" class="float-left m-0 p-0" style="border: 1px solid #bbb; background-color: #eee;">
                <b-table-simple class="smaller p-0 m-0" style="" v-if="assignedTasksWeekly">
                    <b-tr style="" class=""><b-td class="p-1 pl-2 pr-2 m-0"><strong>{{  $t('Entities.UserAccount.UserRoles') + ':'}}</strong><span class="ml-1" v-if="assignedTasksWeekly.userRolesDisplayNames">{{ assignedTasksWeekly.userRolesDisplayNames }}</span><span v-else> no data</span></b-td></b-tr>
                    <b-tr class=""><b-td class="p-1 pl-2 pr-2 m-0"><strong>{{  $t('Entities.StaffUserAccount.StaffCourtRegistryAssignments') + ':' }}</strong><span class="ml-1" v-if="assignedTasksWeekly.courtRegistries">{{ assignedTasksWeekly.courtRegistries }}</span><span v-else> no data</span></b-td></b-tr>
                    <b-tr class=""><b-td class="p-1 pl-2 pr-2 m-0"><strong>{{  $t('Entities.StaffUserAccount.StaffInterviewOrganisationAssignments') + ':' }}</strong><span class="ml-1" v-if="assignedTasksWeekly.interviewOrganisations">{{ assignedTasksWeekly.interviewOrganisations }}</span><span v-else> no data</span></b-td></b-tr>
                </b-table-simple>
            </div>
            <div class="float-left ml-3 w-25" style="border: 1px solid #bbb; background-color: #eee;">
                <b-form-group class="p-2 mb-0" v-if="(otherUsers != null) && (otherUsers.length > 0)">
                    <div>
                        <!-- employmentTypeDisplayName  is the value to group by-->
                        <select2 ref="otherUserSelect"
                                 id="selectedUserAccountId"
                                 name="selectedUserAccountId"
                                 placeholder="Myself"
                                 allow-clear
                                 css-class="form-control-sm"
                                 dropdownCssClass="small"
                                 key-property="userAccountId"
                                 text-property="displayName"
                                 v-model="selectedUserAccountId"
                                 :options="otherUsers"
                                 :render-option-html="renderOptionHtml">

                        </select2>
                    </div>
                    <span class="smaller pl-2" v-if="assignedTasksWeekly">
                        {{ assignedTasksWeekly.userTimeZoneDisplayName }}
                    </span>
                </b-form-group>
            </div>
            <div class="float-right">
                <b-button-toolbar aria-label="Action Buttons">
                    <b-button @click="gotoWeek(-1)" variant="warning" class="mr-2 mb-1"><i class="fas fa-caret-square-left"></i></b-button>
                    <b-button @click="gotoWeek(0)" class="mr-2 mb-1" variant="warning "><i class="fas fa-calendar-day"></i></b-button>
                    <b-button @click="gotoWeek(+1)" class="mr-2 mb-1" variant="warning"><i class="fas fa-caret-square-right"></i></b-button>
                    <b-button variant="warning" class="mb-1" @click="addWeekFromTemplate" v-if="canAddOneMoreWeek && !selectedUserAccountId">Add one more week</b-button>
                </b-button-toolbar>
            </div>
            <div class="float-right mr-4 smaller">
                TVL: Available for Travel<br>
                O/S: Available for On Site<br>
                RT:  Available for Real Time
            </div>
        </div>

        <div style="padding:30px;" v-if="assignedTasksWeekly">
            <b-row v-for="(week,index) in assignedTasksWeekly.weeks" :key="index">
                <b-button v-if="isPastWeek(week)" class="mb-1 mr-3 float-right" size="sm" @click="editAvailabilityWeek(week.year, week.weekNr)" variant="warning"><strong>EDIT Availability for week: {{ week.weekNr }}</strong>  [{{ formatDateTime(week.startDate, 'DD/MM/YYYY', true, true) }} to {{ formatDateTime(week.endDate, 'DD/MM/YYYY', true, true) }}]</b-button>
                <div style="font-size:22px;" class="mr-2">Week {{ week.weekNr }}</div>
                <b-table-simple class="text-center m-10"
                                :fixed="fixed"
                                :bordered="bordered "
                                :small="small"
                                :table-variant="isCurrentWeek(week) ? 'info' : ''"
                                style="float: right; margin-bottom: 30px;">
                    <b-thead>
                        <b-tr>
                            <b-th>Date</b-th>
                            <b-th v-for="(dayObj,dayIndex) in week.days" :key="dayIndex">
                                {{ formatDateTime(dayObj.date, 'ddd DD/MM/YYYY', true, true) }}
                            </b-th>
                        </b-tr>
                    </b-thead>

                    <b-tr>
                        <b-td class="align-middle">
                            <strong>Time Ranges</strong>
                        </b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index" class="m-0 align-middle" style="width: 12.5%;">
                            <!-- show the red badge -->
                            <template v-if="dayObj.reasonUnavailableDisplayName" class="">
                                <b-badge variant="danger" class="p-2 ml-2 mr-2 font-weight-light">{{ dayObj.reasonUnavailableDisplayName }}</b-badge>
                            </template>
                            <!-- show the grey badge -->
                            <template v-else-if="numberOfAvailabletimeSlots(dayObj.timeSlots)==0">
                                <b-link href="#" @click="editAvailabilityDay(dayObj.date, week.weekNr)" class="m-0 p-0">
                                    <b-badge variant="secondary" class="font-weight-light p-2">Add time ranges</b-badge>
                                </b-link>
                            </template>
                            <!-- show the green badges -->
                            <template v-else-if="dayObj.timeSlots.length && numberOfAvailabletimeSlots(dayObj.timeSlots) <= 5 ">
                                <span v-for="(timeSlot,timeSlotIndex) in dayObj.timeSlots" :key="timeSlotIndex">
                                    <b-link href="#" @click="editAvailabilityDay(dayObj.date, week.weekNr)" class="mt-0 pt-0" v-if="timeSlot.selected">
                                        <b-badge v-if="timeSlot.selected" variant="success" class="p-1 w-75 font-weight-light">{{ timeSlot.timeSlotDisplayText }}</b-badge><br />
                                    </b-link>
                                </span>
                            </template>
                            <!-- show the blue badge -->
                            <template v-else-if="numberOfAvailabletimeSlots(dayObj.timeSlots) > 5">
                                <b-link href="#" @click="editAvailabilityDay(dayObj.date, week.weekNr)">
                                    <b-badge variant="primary" class=" font-weight-light p-2">{{  numberOfAvailabletimeSlots(dayObj.timeSlots) }} time ranges</b-badge>
                                </b-link>
                            </template>
                        </b-td>
                    </b-tr>

                    <b-tr v-if="showDelayed">
                        <b-td><strong>Delayed (audio mins)</strong></b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index">
                            <i class="text-secondary fas fa-question" key="emptyday" v-if="isEmptyDay(dayObj)"></i>
                            <template v-else-if="dayObj.audioMinutes">
                                {{ dayObj.audioMinutes }}&nbsp;mins
                            </template>
                            <i class="text-secondary fas fa-minus" v-else></i>
                        </b-td>
                    </b-tr>
                    <b-tr v-if="showOptions">
                        <b-td><strong>Options</strong></b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index" class="p-2">
                            <i class="text-secondary fas fa-question" key="emptyday" v-if="isEmptyDay(dayObj)"></i>
                            <template v-else-if="dayObj.availableForTravel || dayObj.availableForOnSite || dayObj.availableForRealTime">
                                <span class="mr-1 p-1 border border-dark rounded bg-light" vriant="light" v-if="dayObj.availableForTravel">TVL</span>
                                <span class="mr-1 p-1 border border-dark rounded bg-light" v-if="dayObj.availableForOnSite">O/S</span>
                                <span class="mr-1 p-1 border border-dark rounded bg-light" v-if="dayObj.availableForRealTime">RT</span>
                            </template>
                            <i class="text-secondary fas fa-minus" v-else></i>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td><strong>Comments</strong></b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index">
                            <i class="text-secondary fas fa-question" key="emptyday" v-if="isEmptyDay(dayObj)"></i>
                            <b-badge v-b-popover.hover.focus="dayObj.comments" class="p-2" pill variant="info" v-else-if="dayObj.comments">view</b-badge>
                        </b-td>
                    </b-tr>
                </b-table-simple>
            </b-row>
        </div>

        <availability-week-edit :api-controller-url="apiControllerUrl"
                                :title="modalTitle"
                                :year="yearToEdit"
                                :week-nr="weekNrToEdit"
                                :user-account-id="selectedUserAccountId"
                                :timeZoneDisplayString="assignedTasksWeekly!=null ? assignedTasksWeekly.userTimeZoneDisplayName : ''"
                                v-model="showWeekEdit"
                                @availabilityUpdated="loadAvailability">
        </availability-week-edit>

        <availability-day-edit :api-controller-url="apiControllerUrl"
                               :title="dayEditModalTitle"
                               :dateToEdit="dateToEdit"
                               :week-nr="weekNrToEdit"
                               :user-account-id="selectedUserAccountId"
                               :timeZoneDisplayString="assignedTasksWeekly!=null ? assignedTasksWeekly.userTimeZoneDisplayName : ''"
                               v-model="showDayEdit"
                               @availabilityUpdated="loadAvailability">
        </availability-day-edit>

        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Loading..." v-if="showSpinner"></b-spinner>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import AvailabilityWeekEdit from '../Availability/AvailabilityWeekEdit';
    import AvailabilityDayEdit from '../Availability/AvailabilityDayEdit';
    import Select2 from '../Select2';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'AvailabilityCalendar',
        mixins: [ErrorsMixin, DateTimeMixin],
        components: {
            AvailabilityWeekEdit,
            AvailabilityDayEdit
        },
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            imagesUrl: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: 'Availability Calendar'
            },
            otherUsers: {
                type: Array,
                default: null
            },
            canAddOneMoreWeek: {
                type: Boolean,
                required: true
            }
        },
        data: function () {
            return {
                showSpinner: false,
                assignedTasksWeekly: null,
                bordered: true,
                fixed: false,
                small: true,
                yearToEdit: null,
                weekNrToEdit: null,
                showWeekEdit: false,
                showDayEdit: false,
                modalTitle: '',
                dayEditModalTitle: '',
                dateToEdit: null,
                startWeek: null,
                selectedUserAccountId: null,
                selectedUserAccountDisplayName: null,

                // sample code for grouping - https://openbase.com/js/vue-select2/documentation
                // this structure could work for grouping by employment type
                xxx: [{
                    label: 'group1',
                    options: [{ text: 'name1', value: 'val1' }, { text: 'name2', value: 'val2' }]
                }, {
                    label: 'group2',
                    options: [{ text: 'name3', value: 'val3' }, { text: 'name4', value: 'val4' }]
                }]

            }
        },

        computed: {
            showDelayed: function () {
                return this.assignedTasksWeekly.showAudioMinutes;
            },
            showOptions: function () {
                return this.assignedTasksWeekly.showOnSite || this.assignedTasksWeekly.showRealTime || this.assignedTasksWeekly.showTravel;
            }
        },

        watch: {
            selectedUserAccountId: function () {

                if (this.selectedUserAccountId) {
                    var selectedUserAccount = this.$refs.otherUserSelect.getSelectedData();
                    this.selectedUserAccountDisplayName = selectedUserAccount[0].displayName;
                } else this.selectedUserAccountDisplayName = null;
                this.loadAvailability();
            }
        },

        methods: {

            renderOptionHtml: function (userObject) {

                var htmlRenderedOption = '';
                if (userObject.locked) htmlRenderedOption = '<span class="fas fa-lock"></span> ';
                htmlRenderedOption += '<span class="">' + userObject.displayName + ' (' + userObject.employmentTypeDisplayName.charAt(0) + ')</span>';
                return htmlRenderedOption;
            },

            gotoWeek: function (val) {
                if (!this.assignedTasksWeekly) return;
                if (val < 0) {
                    if (!this.assignedTasksWeekly.previousWeek) return;
                    this.startWeek = { year: this.assignedTasksWeekly.previousWeek.year, weekNr: this.assignedTasksWeekly.previousWeek.weekNr };
                } else if (val > 0) {
                    if (!this.assignedTasksWeekly.weeks) return;
                    this.startWeek = { year: this.assignedTasksWeekly.weeks[1].year, weekNr: this.assignedTasksWeekly.weeks[1].weekNr };
                } else {
                    this.startWeek = null;
                }
                this.loadAvailability();
            },

            isCurrentWeek: function (week) {
                var now = new Date();
                return (now >= week.startDate) && (now <= week.endDate)
            },
            isPastWeek: function (week) {
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                return (week.endDate >= today);
            },

            loadAvailability: function () {

                this.showSpinner = true;
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "weeks";
                if (this.startWeek != null) {
                    url += '/';
                    url += this.startWeek.year;
                    url += '/';
                    url += this.startWeek.weekNr;
                }
                if (this.selectedUserAccountId != null) {
                    url += '/';
                    url += this.selectedUserAccountId;
                }
                axios
                    .get(url)
                    .then(response => {
                        this.assignedTasksWeekly = response.data;
                        //here we convert all date values to actual date values (they are returned in the JSON as string)
                        this.assignedTasksWeekly.weeks = this.assignedTasksWeekly.weeks.map((week) => {
                            week.startDate = this.parseDateTime(week.startDate, null, true, true);
                            week.endDate = this.parseDateTime(week.endDate, null, true, true);
                            week.days = week.days.map((day) => {
                                day.date = this.parseDateTime(day.date, null, true, true);
                                return day;
                            });
                            return week;
                        });
                        this.showSpinner = false;
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            addWeekFromTemplate: function () {

                this.showSpinner = true;
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'generateweek';
                axios
                    .get(url)
                    .then((response) => {
                        this.$bvToast.toast('Added one more week successfully (' + response.data.weekNr + '/' + response.data.year + ')', {
                            title: 'Week Added',
                            variant: 'success',
                            appendToast: true
                        });
                        this.loadAvailability();
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            isEmptyDay: function (dayObj) {
                dayObj = false;
                return dayObj;
            },

            editAvailabilityWeek(year, weekNr) {
                this.yearToEdit = year;
                this.weekNrToEdit = weekNr;
                if (!this.selectedUserAccountId) this.modalTitle = "My Availability:";
                else this.modalTitle = "Availability for " + this.selectedUserAccountDisplayName + ":";
                this.modalTitle += " Week " + weekNr;
                this.showWeekEdit = true;
            },

            editAvailabilityDay(dateToEdit, weekNr) {
                this.weekNrToEdit = weekNr;
                this.dateToEdit = dateToEdit;
                if (!this.selectedUserAccountId) this.dayEditModalTitle = "My Availability: ";
                else this.dayEditModalTitle = "Availability for " + this.selectedUserAccountDisplayName + ": ";
                this.dayEditModalTitle += this.formatDateTime(dateToEdit, 'ddd DD/MM/YYYY', true, true) + " (week " + weekNr + ")";
                this.showDayEdit = true;
            },

            numberOfAvailabletimeSlots(timeSlots) {
                var counter = 0;
                for (var i = 0; i < timeSlots.length; i++) {
                    if (timeSlots[i].selected) counter++;
                }
                return counter;
            }
        },

        mounted: function () {
            this.loadAvailability();
        }
    }
</script>

<style scoped>
    div >>> .smaller {
        font-size: 75%;
    }
</style>